<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading">
    Loading
  </a-card>
  <div class="m-position-relative" v-else>
    <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">Petty Cash Report Manifest</div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifest"
                    @click="handlePrint"
                    >Manifest</a-button
                  >
                </li>
                <li v-if="data.iskomisi">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifestkomisi"
                    @click="handlePrintKomisi"
                    >Manifest Komisi</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.user_pembuat.tlc">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.user_pembuat.tlc
                        )
                      "
                      @click="handleEdit"
                      type="dashed"
                      size="small"
                      icon="edit"
                      >Edit</a-button
                    >
                    <a-button
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.user_pembuat.tlc
                        )
                      "
                      @click="handlecanceltrans"
                      type="danger"
                      size="small"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>No. KK</span>
                  <span class="m-list-desc">{{ data.header.no_kk }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    data.header.tanggal_buat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Creator</span>
                  <span class="m-list-desc">{{
                    data.header.user_pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total Petty Cash</span>
                  <span class="m-list-desc">{{
                    formatRupiah(data.header.total_klaim_kas)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{
                    data.header.catatan ? data.header.catatan :'-'
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse v-if="getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-list
                itemLayout="vertical"
                :dataSource="data.detail_invoice"
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <span slot="title">{{
                      item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                    }}</span>
                    <div slot="description" class="margin-remove">
                      <span>{{
                        moment(item.tanggal).format(getDefaultDateFormat)
                      }}</span>
                      <div>
                        <span>{{ item.label }}</span>
                        <h4 class="margin-remove">
                          {{ formatRupiah(item.nilai) }}
                        </h4>
                      </div>
                      <a-button-group v-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                        <a-button type="primary" icon="edit" @click="handleUploadDoc(item)" :loading="uploadDoc.loading2 && uploadDoc.loading2key == item.id_dtl"></a-button>
                        <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                        <a-button type="default" disabled v-else>No File</a-button>
                      </a-button-group>
                        <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" class="margin-top">
                          View Document
                        </a>
                        <div v-else class="margin-top">
                          :: No File Uploaded ::
                        </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-table
                rowKey="key"
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <template slot="title" slot-scope="">
                  <div class="m-display-flex space-between align-middle">
                      <div class="H-tb"><b>PETTY CASH</b></div>
                      <a-input-search
                        v-model="search"
                        placeholder="Quick Search Petty Cash"
                        allowClear
                        :change="searching"
                        style="max-width: 45%;"
                      />
                    </div>
                </template>
                <template slot="deskripsi" slot-scope="item">
                  <span>{{ item.deskripsi }}</span
                  ><br />
                  <small>{{ item.end_user ? item.end_user : "-" }}</small>
                </template>
                <template slot="item_anggaran" slot-scope="item">
                  <span>
                    {{ item.item_anggaran }}
                  </span>
                  <br />
                  <span>
                    {{ item.kode_anggaran }}
                  </span>
                </template>
                <template slot="prospect" slot-scope="item">
                  <span>
                    {{ item.no_prospek ? item.no_prospek : '-'}}
                  </span>
                  <br />
                  <span>
                    {{ item.description }}
                  </span>
                </template>
                <template slot="document" slot-scope="index, item">
                  <span v-if="item.deskripsi.toLowerCase() == 'kas kecil'"></span>
                  <a-button-group v-else-if="data.user_pembuat.tlc == getAuth.username">
                    <a-button type="primary" icon="edit" @click="handleUploadDoc(item)" :loading="uploadDoc.loading2 && uploadDoc.loading2key == item.id_dtl"></a-button>
                    <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                    <a-button type="default" disabled v-else>No File</a-button>
                  </a-button-group>
                  <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                    View Document
                  </a>
                  <span v-else>
                    No File Uploaded
                  </span>
                </template>
                <span slot="debit" slot-scope="debit">
                  <CurrencyJustified
                    v-if="debit.val"
                    :currencyValue="debit.curr"
                    :valueNumber="debit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="kredit" slot-scope="kredit">
                  <CurrencyJustified
                    v-if="kredit.val"
                    :currencyValue="kredit.curr"
                    :valueNumber="kredit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="sisa" slot-scope="sisa">
                  <CurrencyJustified
                    :currencyValue="sisa.curr"
                    :valueNumber="sisa.val"
                  />
                </span>
                <div slot="footer">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      ><b>Total Petty Cash</b></a-col
                    >
                    <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                      <CurrencyJustified
                        :currencyValue="currtotalSaldo"
                        :valueNumber="Number(data.header.total_klaim_kas)"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                </div>
              </a-table>

              <div v-if="tableDataBailoutTemp && tableDataBailoutTemp.length>0">
                <a-table
                  rowKey="id_bailout"
                  :columns="columnsbailout"
                  :dataSource="tableDataBailout"
                  :pagination="paginationBailout"
                  size="small"
                  bordered
                  :scroll="{ x: 500 }"
                >
                  <template slot="title" slot-scope="">
                    <div class="m-display-flex space-between align-middle">
                      <div class="H-tb"><b>BAILOUT</b></div>
                      <a-input-search
                        v-model="searchBailout"
                        placeholder="Quick Search Bailout"
                        allowClear
                        @change="searchingBailout"
                        style="max-width: 45%;"
                      />
                    </div>
                  </template>
                  <template slot="nopppd" slot-scope="text, item">
                    <span>{{ item.no_sppd ? item.no_sppd : "-" }}</span>
                  </template>
                  <template slot="bailoutvalue" slot-scope="text, item">
                    <CurrencyJustified
                      currencyValue="IDR"
                      :valueNumber="item.bailout_value"
                    />
                  </template>
                  <div slot="footer">
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left"
                        ><b>Total Bailout</b></a-col
                      >
                      <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                        <CurrencyJustified
                          :currencyValue="currtotalSaldo"
                          :valueNumber="totalBailout"
                        />
                      </a-col>
                      <a-col
                        :span="3"
                        :order="3"
                        class="m-text-align left m-text-bold"
                      ></a-col>
                    </a-row>
                  </div>
                </a-table>
              </div>

              <div class="container-essential">
                <a-row type="flex" >
                  <a-col :span="10" :order="1" class="m-text-align left"
                    >Total Debit</a-col
                  >
                  <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                    <CurrencyJustified
                      :currencyValue="currtotalSaldo"
                      :valueNumber="totalDebit"
                    />
                  </a-col>
                  <a-col
                    :span="3"
                    :order="3"
                    class="m-text-align left m-text-bold"
                  ></a-col>
                </a-row>
                <a-row type="flex">
                  <a-col :span="10" :order="1" class="m-text-align left"
                    >Total Credit (Petty Cash{{ tableDataBailout && tableDataBailout.length>0 ? ' + Bailout' : ''}})</a-col
                  >
                  <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                    <CurrencyJustified
                        :currencyValue="currtotalSaldo"
                        :valueNumber="Number(data.header.total_klaim_kas)+totalBailout"
                      />
                  </a-col>
                  <a-col
                    :span="3"
                    :order="3"
                    class="m-text-align left m-text-bold"
                  ></a-col>
                </a-row>
                <a-divider v-if="!isShowColDebit"></a-divider>
                <a-row type="flex" >
                  <a-col :span="10" :order="1" class="m-text-align left"
                    >Remaining Balance</a-col
                  >
                  <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                    <CurrencyJustified
                      :currencyValue="currtotalSaldo"
                      :valueNumber="totalSaldo-totalBailout"
                    />
                  </a-col>
                  <a-col
                    :span="3"
                    :order="3"
                    class="m-text-align left m-text-bold"
                  ></a-col>
                </a-row>
              </div>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="margin-top"
            :loading="pageLoading"
            v-if="
              data.jenis.toLowerCase() !== 'manifest' &&
              data.jenis.toLowerCase() !== 'transfer'
            "
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                  showSearch
                  v-decorator="[
                    'aksi',
                    {
                      rules: [{ required: true }],
                      initialValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
            <template class="ant-card-actions" slot="actions">
              <a-button
                @click="handleActionConfirm"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </template>
          </a-card>
          <a-card
            class="margin-top"
            :loading="pageLoading"
            v-if="
              data.jenis.toLowerCase() === 'transfer' && data.status_transfer
            "
          >
            <div slot="title">Manifest Actions</div>
            <div slot="extra">
              <h5 class="m-text-align right margin-remove">
                Remaining Balance
              </h5>
              <h4 class="m-text-align right margin-remove">
                {{ formatRupiah(data.sisa_tf) }}
              </h4>
            </div>

            <a-form :form="form">
              <a-form-item label="Aksi">
                <a-select
                  showSearch
                  @change="handleAksi"
                  v-decorator="[
                    'status',
                    {
                      rules: [{ required: true }],
                      initialValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item v-if="!isRevised" label="Transfer Date">
                <a-date-picker
                  placeholder="Select Date"
                  :format="getDefaultDateFormat"
                  v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                />
              </a-form-item>
              <a-form-item v-if="!isRevised" label="Evidence of Transfer">
                <a-upload
                  accept="image/*"
                  :showUploadList="true"
                  :fileList="push"
                  listType="picture"
                  :beforeUpload="beforeUpload"
                  v-decorator="[
                    'upload',
                    { rules: [{ required: true }] },
                    { valuePropName: 'push' },
                  ]"
                >
                  <a-button>
                    <a-icon type="upload" />&nbsp;Select File
                  </a-button>
                </a-upload>
              </a-form-item>
              <a-form-item v-if="!isRevised" label="Transfer Value">
                <a-input-number
                  :disabled="disabled"
                  type="number"
                  :max="data.sisa_tf"
                  class="m-width-full m-text-align right"
                  :formatter="
                    (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-decorator="[
                    'value_transferan',
                    { rules: [{ required: true }], initialValue: data.sisa_tf },
                  ]"
                />
              </a-form-item>
              <a-checkbox
                class="margin-bottom"
                @change="handleCheckData"
                :checked="checkTransferValue"
                v-if="!isRevised"
                >The transferred value matches the remaining balance</a-checkbox
              >
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['remark']"
                />
              </a-form-item>
            </a-form>
            <template class="ant-card-actions" slot="actions">
              <a-button
                @click="handleActionConfirm"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </template>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">Evidence of Transfer</div>
            <div>
              <a-alert
                v-if="
                  data.bukti_transfer === null ||
                  data.bukti_transfer.length === 0
                "
                type="error"
                message="No evidence of transfer was uploaded"
                banner
              />
              <a-list
                itemLayout="horizontal"
                :dataSource="data.bukti_transfer"
                v-else
              >
                <Empty
                  v-if="
                    data.bukti_transfer !== null
                      ? data.bukti_transfer.length <= 0
                      : data.bukti_transfer
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <div>
                        <h4 class="margin-remove">
                          {{ item.no_kas_masuk }}
                        </h4>
                        <h5 class="margin-remove">{{ item.tgl_tf }} | {{ item.user_tf }}</h5>
                        <h4 class="margin-remove">
                          {{ formatCurrency(item.currency, item.value_tf) }}
                        </h4>
                      </div>
                      <a-button
                        @click="handleView(item)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                    </div>
                    <Mis-Image
                      class="m-image-icon"
                      slot="avatar"
                      :source="$serviceUrl + item.url"
                    />
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status
                    :status="
                      data.last_status == 'Canceled'
                        ? 'Cancelled'
                        : data.last_status
                    "
                  />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.user_pembuat.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        data.user_pembuat.tanggal
                      }}
                    </h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                  :color="
                    workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                      ? 'red'
                      : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                  "
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor ? workflow.actor : workflow.jenis }}
                    {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-modal v-model="visibleUploadDoc" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="upload" />&nbsp;Upload Transaction Document </span>
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="uploadDoc.loading"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <b>Tanggal</b>
          </a-col><a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
            <a-input v-model="uploadDoc.tanggal" disabled></a-input>
          </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Description</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-textarea v-model="uploadDoc.deskripsi" disabled></a-textarea>
            </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Transaction Document</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-upload
                :showUploadList="true"
                :fileList="uploadDoc.doctransfiles"
                :beforeUpload="beforedoctransUpload"
                v-model="uploadDoc.file"
                :disabled="uploadDoc.loading"
              >
              <!-- :remove="handledoctransRemove" -->
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-col>
        </a-row>
      </a-spin> 
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ManifestKasKecil",
  components: { Status },
  props: ["id"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      visibleHistory: false,
      pageLoading: true,
      disabled: true,
      data: {},
      push: [],
      pagination: {
        onChange: (page) => {},
        pageSize: 10,
        size: "small",
      },
      paginationBailout: {
        onChange: (page) => {},
        pageSize: 10,
        size: "small",
      },
      printLoad: {
        cancel: false,
        manifest:false,
        manifestkomisi:false,
      },
      tableData: [],
      tableDataTemp: [],
      tableDataBailout: [],
      tableDataBailoutTemp: [],
      search: "",
      searchBailout: "",
      totalSaldo: {},
      currtotalSaldo: "",
      totalDebit: {},
      isShowColDebit: true,
      checkTransferValue: true,
      isRevised: false,
      listpimprodtl: [],
      visibleUploadDoc: false,
      uploadDoc: {
        file: null,
        doctransfiles: null,
        id_dtl_trans: null,
        tanggal: null,
        deskripsi: null,
        loading: false,
        loading2: false,
        loading2key: "",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.push = [];
        this.checkTransferValue = true;
        this.disabled = true;
        this.isRevised = false;
        this.search = "";
      }

      if (!this.getScreen) {
        this.getDetailPemakaianWeb();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const kolom = this.isShowColDebit
        ? [
            {
              title: "No",
              dataIndex: "no",
              key: "no",
              width: 60,
              sorter: (a, b) => a.no.length - b.no.length,
              fixed: "left",
            },
            {
              title: "Tanggal",
              dataIndex: "tanggal",
              width: 150,
              key: "tanggal",
              sorter: (a, b) =>
                new Date(
                  moment(a.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ) -
                new Date(
                  moment(b.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ),
              fixed: "left",
            },
            {
              title: "Deskripsi",
              scopedSlots: { customRender: "deskripsi" },
              key: "deskripsi",
              width: this.isShowColDebit ? 350 : 200,
              sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
            },
            {
              title: "Item Anggaran",
              dataIndex: "item_anggaran",
              key: "item_anggaran",
              width: 200,
              sorter: (a, b) => a.item_anggaran.length - b.item_anggaran.length,
            },
            {
              title: "Prospect",
              key: "prospect",
              scopedSlots: { customRender: "prospect" },
              width: 150,
              align: "left"
            },
            {
              title: "Document",
              key: "document",
              scopedSlots: { customRender: "document" },
              width: 150,
              align: "center"
            },
            {
              title: "Kredit",
              dataIndex: "kredit",
              key: "kredit",
              width: 200,
              sorter: (a, b) => a.kredit.val.length - b.kredit.val.length,
              fixed: "right",
              scopedSlots: { customRender: "kredit" },
            },
          ]
        : [
            {
              title: "No",
              dataIndex: "no",
              key: "no",
              width: 60,
              sorter: (a, b) => a.no.length - b.no.length,
              fixed: "left",
            },
            {
              title: "Tanggal",
              dataIndex: "tanggal",
              width: 100,
              key: "tanggal",
              sorter: (a, b) =>
                new Date(
                  moment(a.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ) -
                new Date(
                  moment(b.tanggal, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ),
              fixed: "left",
            },
            {
              title: "Deskripsi",
              scopedSlots: { customRender: "deskripsi" },
              key: "deskripsi",
              width: 200,
              sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
            },
            {
              title: "Item Anggaran",
              key: "item_anggaran",
              width: 200,
              scopedSlots: { customRender: "item_anggaran" },
              sorter: (a, b) => a.item_anggaran.length - b.item_anggaran.length,
            },
            {
              title: "Prospect",
              key: "prospect",
              scopedSlots: { customRender: "prospect" },
              width: 150,
              align: "left"
            },
            {
              title: "Document",
              key: "document",
              scopedSlots: { customRender: "document" },
              width: 150,
              align: "center"
            },
            {
              title: "Debit",
              dataIndex: "debit",
              key: "debit",
              width: 200,
              sorter: (a, b) => a.debit.length - b.debit.length,
              scopedSlots: { customRender: "debit" },
            },
            {
              title: "Kredit",
              dataIndex: "kredit",
              key: "kredit",
              width: 200,
              sorter: (a, b) => a.kredit.val.length - b.kredit.val.length,
              scopedSlots: { customRender: "kredit" },
            },
            {
              title: "Saldo",
              dataIndex: "sisa",
              key: "sisa",
              width: 200,
              sorter: (a, b) => a.sisa.length - b.sisa.length,
              fixed: "right",
              scopedSlots: { customRender: "sisa" },
            },
          ];
      return kolom;
    },
    columnsbailout() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 30,
          align: "center",
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "No PP/PD Transaction",
          key: "nopppd",
          width: 150,
          scopedSlots: { customRender: "nopppd" },
          sorter: (a, b) => a.no_sppd - b.no_sppd,
        },
        {
          title: "Bailout Value",
          key: "bailoutvalue",
          align: "right",
          width: 150,
          scopedSlots: { customRender: "bailoutvalue" },
          sorter: (a, b) => a.bailout_value - b.bailout_value,
        },
      ];

      if (this.picForColumn !== this.getAuth.username) {
        //kolom.splice(5, 1);
        kolom.splice(6, 1);
      }
      return kolom;
    },
    searching() {
      if (this.search) {
        this.tableData = this.tableData.filter(
          (obj) =>
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.alokasi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.proyek.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.tanggal, "DD-MM-YYYY")
              .format("DD-MM-YYYY")
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
    picKasKecil() {
      if (this.getAuth.job_desc[0] === "Kas Kecil") {
        return true;
      }
      return false;
    },
    totalBailout(){
      return _.sumBy(this.tableDataBailoutTemp, function (val) {return Number(val.bailout_value)})
    }
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "kas_kecil",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            header: {
              no_kk: response.data.invoice[0].no_kas,
              tanggal_buat: response.data.invoice[0].tanggal,

              user_pembuat: response.data.invoice[0].nama,
              total_klaim_kas: response.data.invoice[0].total_klaim_kas || 0,
              catatan: response.data.invoice[0].catatan
            },
            jenis: response.data.jenis,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].tanggal,

              status: "Created",
            },
            sisa_tf: response.data.sisa_tf,
            aksi: response.data.aksi,
            bukti_transfer: response.data.detail_bukti_transfer,
            detail_invoice: response.data.dtl_invoice,
            dokumen_terkait: response.data.dokumen_terkait,
            status: response.data.status_app,
            history: response.data.notifikasi,
            status_transfer: response.data.status_transfer,
            iskomisi: response.data.iskomisi,
          };
          this.totalDebit = response.data.total_debit;
          this.totalSaldo =
            parseFloat(response.data.total_debit) -
            parseFloat(response.data.invoice[0].total_klaim_kas?response.data.invoice[0].total_klaim_kas:0);

          this.data.detail_invoice.forEach((value, index) => {
            this.listpimprodtl.push({
              key: index + 1,
              no: index + 1,
              proyek: value.proyek,
              alokasi: value.alokasi,
              currency: value.currency,
              kredit: {
                curr: value.currency,
                val: Number(value.label == "Kredit" ? value.nilai : 0),
              },
              debet: {
                curr: value.currency,
                val: Number(value.label == "Kredit" ? 0 : value.nilai),
              },
              sisa: Number(0),
              tanggal: moment(value.tanggal).format(this.getDefaultDateFormat),
              deskripsi: value.deskripsi,
              item_anggaran: value.item_anggaran,
              kode_anggaran: value.kode_anggaran,
              end_user: value.end_user
            });
          });

          let dtbailout = response.data.dtl_bailout
          dtbailout.forEach((element,index) => {
            element['no'] = index+1;
          });
          this.tableDataBailout = dtbailout
          this.tableDataBailoutTemp = dtbailout

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint(item) {
      //console.log(item);
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "kas_kecil/cetak_laporan_kas_kecil",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_kas: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
            this.printLoad.manifest = false;
          window.open(url, "_blank");
          this.pageLoading = false;
        })
        .catch((err) => {
          this.printLoad.manifest = false;
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    handlePrintKomisi(item) {
      //console.log(item);
      this.printLoad.manifestkomisi = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "kas_kecil/cetak_laporan_kas_kecil_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_kas: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
            this.printLoad.manifestkomisi = false;
          window.open(url, "_blank");
          this.pageLoading = false;
        })
        .catch((err) => {
          this.printLoad.manifestkomisi = false;
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    handleAction() {
      if (this.data.jenis.toLowerCase() === "transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          let post = new FormData();
          post.append("id_kas", this.id);
          post.append("tlc", this.getAuth.username);
          post.append("status", values.status);
          post.append("remark", values.remark);
          post.append(
            "tgl_tf",
            moment(values.tgl_trf).format(this.getStandartFormatDate)
          );
          post.append("value_transferan", values.value_transferan);
          post.append("file_transfer", this.push[0]);

          axios({
            method: "post",
            url: this.$serviceUrl + "kas_kecil/approval ",
            processData: false,
            data: post,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "kas_kecil/approval ",
            processData: false,
            data: {
              id_kas: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan ? values.catatan : "",
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then(() => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
    handleCheckData(e) {
      if (e.target.checked) {
        this.disabled = true;
        this.checkTransferValue = true;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf,
        });
      } else {
        this.disabled = false;
        this.checkTransferValue = false;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf,
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleView(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(this.$serviceUrl + file.url, "_blank");
      } else {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      }
    },
    getDetailPemakaianWeb() {
      if (this.getAuth.pimpro[0] == "1") {
        this.isShowColDebit = true;
        this.tableData = this.listpimprodtl;
        this.tableDataTemp = this.listpimprodtl;
        this.currtotalSaldo = this.listpimprodtl[0]
          ? this.listpimprodtl[0].currency
          : "IDR";
      } else {
        axios({
          method: "get",
          url: this.$serviceUrl + "kas_kecil/web_detil_pemakaian",
          params: {
            id: this.id,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.totalDebit = response.data.debit;
            let dataPemakaian = response.data.detail_pemakaian;
            response.data.detail_pemakaian.forEach((value, index) => {
              if (value.debit !== "-") {
                dataPemakaian[index]["debit"] = {
                  curr: value.currency,
                  val: Number(value.debit),
                };
              }

              if (value.kredit !== "-") {
                dataPemakaian[index]["kredit"] = {
                  curr: value.currency,
                  val: Number(value.kredit),
                };
              }
              dataPemakaian[index]["sisa"] = {
                curr: value.currency,
                val: Number(value.sisa),
              };
              if (value.tanggal !== "-") {
                dataPemakaian[index]["tanggal"] = moment(value.tanggal).format(
                  this.getDefaultDateFormat
                );
              }
              if (
                this.isShowColDebit === true &&
                dataPemakaian[index]["deskripsi"].toLowerCase() === "kas kecil"
              ) {
                this.isShowColDebit = false;
              }
            });

            this.tableData = dataPemakaian;
            this.tableDataTemp = dataPemakaian;
            this.totalSaldo = dataPemakaian[dataPemakaian.length - 1].sisa.val ? 
              dataPemakaian[dataPemakaian.length - 1].sisa.val : dataPemakaian[dataPemakaian.length - 1].sisa ;
            this.currtotalSaldo =
              dataPemakaian[dataPemakaian.length - 1].sisa.curr;
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.displayMessage("404");
            }
            this.pageLoading = false;
            this.$router.go(-1);
          });
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAksi(e) {
      if (e == "Revised") {
        this.isRevised = true;
        this.disabled = false;
        this.push = [];
      } else {
        this.disabled = true;
        this.isRevised = false;
      }
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "kas",
        id_manifest: this.id,
        code_trans: this.data.header.no_kk,
        kode_project: null,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "kasKecilEdit",
        params: { id: this.id, type: "revised" },
      });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleUploadDoc(item) {
      this.uploadDoc.tanggal = item.tanggal;
      this.uploadDoc.deskripsi = item.deskripsi;
      this.uploadDoc.id_dtl_trans = item.id_dtl;

      this.uploadDoc.doctransfiles = [];

      if (item.lampiran) {
        this.uploadDoc.loading2 = true;
        this.uploadDoc.loading2key = item.id_dtl;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
          .then((response) => {
            let typefile = this.fileTypeFromUrl(item.lampiran);
            let file = this.dataURLtoFile(
              typefile + response.file_document_tax,
              item.lampiran
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + item.lampiran_path;
            this.uploadDoc.doctransfiles = [];
            this.uploadDoc.doctransfiles.push(file);

            this.uploadDoc.loading2 = false;
            this.uploadDoc.loading2key = "";
            this.visibleUploadDoc = true;
          })
          .catch((err) => {
            this.uploadDoc.loading2 = false;
            this.uploadDoc.loading2key = "";
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.visibleUploadDoc = true;
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let data = new FormData();
        data.append("tipe_trans", "kas_kecil");
        data.append("id_dtl_trans", this.uploadDoc.id_dtl_trans);
        data.append("file_upload", file);

        this.uploadDoc.loading = true;
        this.asyncAxiosPost("main/upload_lampiran", "formdata", this.getAuth, data)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.uploadDoc.loading = false;
            this.getDetailPemakaianWeb();
            this.visibleUploadDoc = false;
          })
          .catch((err) => {
            console.log(err);
            this.uploadDoc.loading = false;
            if (err.response && err.response.data) {
              this.$notification.error({
                message: "Error Message",
                description: err.response.data.message,
              });
            } else {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            }
          });
        this.uploadDoc.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.uploadDoc.doctransfiles = [];
    },
    searchingBailout() {
      if (this.searchBailout) {
        this.tableDataBailout = this.tableDataBailoutTemp.filter(
          (obj) =>
            (obj.no_sppd && obj.no_sppd.toLowerCase().indexOf(this.searchBailout.toLowerCase()) >=
              0) ||
            (obj.deskripsi && obj.deskripsi.toLowerCase().indexOf(this.searchBailout.toLowerCase()) >= 0) ||
            obj.bailout_value && this.formatCurrency('IDR', obj.bailout_value).toLowerCase().indexOf(this.searchBailout.toLowerCase()) >= 0
        );
      }

      if (!this.searchBailout) {
        this.tableDataBailout = this.tableDataBailoutTemp;
      }

      return this.tableDataBailout;
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleAction);
    if (!this.getScreen) {
      this.getDetailPemakaianWeb();
    }
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
    Event.$off("handleCancel", this.canceltrans);
  },
};
</script>

<style scoped lang="less">
.m-image-icon {
  width: 50px;
}

.H-tb{
  color : @color-secondary;
  text-align: center;
}
</style>
